export default {
  role: 'user'
}
